/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';

import {User} from '../_models/user';
import {Observable} from 'rxjs';
import {AbstractService, RESPONSE} from './abstract.service';
import {QueryParams, QueryParamsHelper} from '../_helpers/query-params.helper';

@Injectable()
export class UserService extends AbstractService<User> {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string, protected httpClient: HttpClient) {
    super(locale, httpClient, 'user', 'users');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                GET                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public getCurrent(qp?: QueryParams): Observable<HttpResponse<User>> {
    return this.httpClient.get<User>(`${this.singleUrl}/current`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                               PATCH                                                                ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public updatePassword(oldPassword: string, newPassword: string, qp?: QueryParams): Observable<HttpResponse<User>> {
    return this.httpClient.patch<User>(`${this.singleUrl}/current/password`, JSON.stringify({
        old_password: oldPassword,
        new_password: newPassword
      }),
      {
        headers: QueryParamsHelper.getHttpHeaders(qp),
        params: QueryParamsHelper.getHttpParams(qp),
        observe: RESPONSE,
        reportProgress: false
      });
  }

  public updateEmail(newEmail: string, qp?: QueryParams): Observable<HttpResponse<User>> {
    return this.httpClient.patch<User>(`${this.singleUrl}/current/email`, JSON.stringify({
      new_email: newEmail
    }), {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                POST                                                                ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public forgotPassword(email: string, qp?: QueryParams): Observable<any> {
    return this.httpClient.post<any>(`${this.singleUrl}/password/forgot`, JSON.stringify({email: email}), {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  public resetPassword(password: string, token: string, qp?: QueryParams): Observable<any> {
    return this.httpClient.post<any>(`${this.singleUrl}/password/reset`, JSON.stringify({new_password: password, token: token}), {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

}
